import { getCartItemsForDataLayer } from "./analytics";
import { CartId } from "./types";

export function listenToCheckoutButtonClick() {
    $(`#${CartId.BtnCheckout}`).on("click", function (e) {
        e.preventDefault();

        $.post("/api/User/GetMemberInformation", function (data) {
            if (data.isLoggedIn) {
                SaSpinnerUtils.ShowFullPageSpinner();
                $.ajax({
                    type: "post",
                    url: "/api/Cart/Checkout",
                    success: function (data) {
                        if (data.success) {
                            SaAnalyticsUtils.addToDataLayer(
                                SaAnalyticsUtils.buildBeginCheckoutEventFromItems(
                                    getCartItemsForDataLayer(),
                                ),
                            );

                            SaNavigationUtils.navigateWithHistory(data.url);
                        } else {
                            SaSpinnerUtils.HideFullPageSpinner();
                            SaAlertUtils.defaultFire(
                                "Checkout Error",
                                "Unable to start checkout. Please try again later.",
                            );
                        }
                    },
                    error: function (xhr) {
                        // backend checkout validation returns
                        // 400/409 ApiResponse errors. show them instead of failing silently.
                        SaSpinnerUtils.HideFullPageSpinner();
                        SaAlertUtils.defaultFireFromResponse(
                            "Checkout Error",
                            xhr,
                        );
                    },
                });
            } else {
                SaCartUtils.showLoginModal();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "page_view",
                    page_title: "Login Gate",
                    page_location: "/virtual/login-gate",
                });
            }
        });
    });
}
